import { ResourceOptions } from 'react-admin';
import { MdDomain } from 'react-icons/md';
import { Resources } from '../resource';
import './init';

export { default as list } from './List';

export const name = Resources.domainConfigs;
export const icon = MdDomain;
export const options: ResourceOptions = {
  label: 'resource.domainConfigs',
};
